import { makeStyles } from "@material-ui/core";

export const quickwinHeaderStyles = makeStyles((theme) => ({
  container: {
    padding: "35px 140px",
    marginBottom: "25px",
    backgroundColor: "#F1F5F9",
  },
  newQuickwinHeader: {
    backgroundColor: "#F1F5F9",
  },
  completedQuickwinHeader: {
    backgroundColor: "#E7F9EE",
  },
  quickWinText: {
    color: "#0F172A",
    fontFamily: "Lato",
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 400,
  },
  message: {
    color: "#000000",
    fontSize: theme.typography.pxToRem(20),
    fontFamily: "Inter",
    fontWeight: 600,
  },
  buttonsContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  laterButton: {
    color: "#0344DC",
    marginRight: "24px",
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 600,
  },
  nextButton: {
    backgroundColor: "#0344DC",
    color: "white",
    borderRadius: "20px",
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(14),
    textTransform: "none",
    whiteSpace: "nowrap",
    "&:hover": {
      backgroundColor: "#022984",
    },
    "& .MuiButton-endIcon": {
      color: "#22D9BB",
    },
  },
  disabledNextButton: {
    backgroundColor: "transparent !important",
    color: "#666666 !important",
    border: "1px solid #999999",
    "& .MuiButton-endIcon": {
      color: "#999999",
    },
  },
  link: {
    textDecoration: "none",
    fontWeight: 600,
    cursor: "pointer",
  },
  successMessage: {
    marginLeft: "8px",
    color: "#0ABF52",
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(20),
  },
  successBackground: {
    backgroundColor: "#E7F9EE",
  },
  successContainer: {
    display: "flex",
    alignItems: "center",
  },
  mentorTipIcon: {
    marginRight: "20px",
  },
}));
